<div
    class="tw-flex tw-justify-evenly sm:tw-p-6 tw-h-[100vh] tw-gap-5 sm:tw-bg-[#0A0A75] tw-bg-transparent tw-items-start sm:tw-items-center"
>
    <div
        class="tw-w-full sm:tw-w-[80%] lg:tw-w-[60%] tw-pt-4 tw-pb-10 xl:tw-w-[36%] tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2]"
    >
        <header class="tw-text-center">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-min-h-[4rem] tw-px-8 md:tw-px-10"
            >
                <div class="tw-flex-1"></div>
                <img
                    src="/assets/images/logo/header_desktop.webp"
                    alt="IMSME Logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[35%] tw-mx-auto"
                    [routerLink]="['/home']"
                />
                <div
                    class="tw-text-[16px] tw-font-medium tw-flex-1 tw-text-right"
                >
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('en')"
                        >{{ "LANG.EN" | translate }}</span
                    >
                    |
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('bm')"
                        >{{ "LANG.BM" | translate }}</span
                    >
                </div>
            </div>
        </header>
        <div class="tw-px-8 md:tw-px-16 tw-mt-2">
            <div
                class="tw-text-[24px] md:tw-text-[28px] tw-font-semibold tw-w-full"
            >
                {{ "COMMON.FORGOT_PASSWORD" | translate }}
            </div>
        </div>
        <div
            class="tw-px-8 tw-mt-4 md:tw-px-16 tw-flex-1 tw-min-h-0 tw-flex tw-flex-col"
        >
            <form
                [formGroup]="forgotPasswordForm"
                (ngSubmit)="onForgotPassword()"
                class="tw-h-full tw-flex tw-flex-col tw-relative"
            >
                <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center">
                    <input-general
                        class="tw-block tw-w-[100%] tw-rounded-2xl"
                        [mandatoryField]="true"
                        [label]="'FORM.USERID_EMAIL' | translate"
                        [placeHolder]="'Mohd_Abu'"
                        [controlName]="'username'"
                        [errors]="
                            getErrors('username', 'FORM.EMAIL' | translate)
                        "
                    ></input-general>

                    <re-captcha
                        class="tw-block tw-mt-5 g-recaptcha"
                        formControlName="recaptcha"
                        [siteKey]="siteKey"
                        (resolved)="onCheckCaptcha($event)"
                    >
                    </re-captcha>

                    <button
                        class="tw-mt-5 tw-rounded-[32px] tw-text-white tw-font-bold tw-h-[56px] tw-w-full tw-text-[16px]"
                        type="submit"
                        [ngClass]="
                            forgotPasswordForm.invalid
                                ? 'tw-bg-[#FFA53C] tw-opacity-50'
                                : 'tw-bg-[#FFA53C]'
                        "
                    >
                        {{ "COMMON.CONTINUE" | translate }}
                    </button>
                </div>

                <div
                    class="tw-flex tw-flex-col tw-gap-4 tw-bg-white tw-text-[#7B7575]"
                >
                    <div class="tw-text-center tw-mt-6">
                        <div
                            class="tw-underline access-btn"
                            (click)="goToSignUp()"
                        >
                            {{ "REGISTER_TITTLE" | translate }}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <img
        class="tw-hidden sm:tw-block tw-absolute tw-left-0 tw-bottom-0"
        src="../../../../assets/images/login-signup/Blue-1.png"
        alt="Blue Img"
    />
</div>
